'use client';

import dynamic from 'next/dynamic';

const RecentlyUsedTools = dynamic(
  () => import('@/components/RecentlyUsedTools'),
  { ssr: false }
);

export default function RecentlyUsedToolsWrapper() {
  return <RecentlyUsedTools />;
}
